<template>
  <j-modal :title="title"
           :width="width"
           :visible="visible"
           switchFullscreen
           @ok="handleOk"
           :okButtonProps="{ props: { disabled: disableSubmit } }"
           v-bind="setFooter()"
           @cancel="handleCancel">
    <!-- 新增，引导式 -->
    <TenantAdd ref="tenantAdd" v-if="!isEdit" @success="submitCallback" />
    <!-- 编辑，只能编辑基础信息 -->
    <tenant-form ref="realForm" v-if="isEdit" @ok="submitCallback" :disabled="disableSubmit" normal />
  </j-modal>
</template>

<script>
import TenantForm from './TenantForm'
import TenantAdd from '@views/system/modules/TenantAdd'

export default {
  name: 'TenantModal',
  title: '租户管理新增编辑',
  components: {
    TenantAdd,
    TenantForm
  },
  data() {
    return {
      title: '',
      width: '50%',
      visible: false,
      disableSubmit: false,
      isEdit: false
    }
  },
  methods: {
    setFooter() {
      if (!this.isEdit) return { footer: null }
      return {}
    },
    add() {
      this.visible = true
      this.isEdit = false
    },
    edit(record) {
      this.visible = true
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>